import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { IDashboardState, IState } from '../states';

function createCarriersSelectors(
  dashboardFeatureSelector: MemoizedSelector<IState, IDashboardState, DefaultProjectorFn<IDashboardState>>,
) {
  const selectActiveCarriersAndTotalShipmentsList = createSelector(
    dashboardFeatureSelector,
    (state) => state.carriers.activeCarriersAndTotalShipmentsList,
  );

  return {
    selectActiveCarriersAndTotalShipmentsList,
  };
}

export default createCarriersSelectors;
